import React, { useEffect, useState } from "react";
import baseURL from "../../authComponents/baseURL/BaseURL";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);

  
  useEffect(()=>{

    async function fetchBlogs() {
      const blogsResp = await fetch(baseURL + "/blogs")
      const blogsData = await blogsResp.json();
      setBlogs(blogsData)
    }
  }, [])
  return (
    <>
      <div className="flex flex-col gap-6 bg-gray-100 p-3">
        <div className="flex flex-row items-center justify-between">
          <h1 style={{ fontFamily: "serif" }}>Blogs</h1>
          <Link type="button" class="text-white bg-gradient-to-r from-purple-500 to-pink-500 hover:bg-gradient-to-l focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Purple to Pink</Link>
        </div>
        <hr/>
        <div className="flex flex-col gap-3">
          
          <div className="flex flex-row gap-5 bg-blue-100">
            <img src="https://cdn.prod.website-files.com/621ce1736f293c5bb7029149/65a54274254aafd1312ee5d3_pexels-summer-stock-285938.jpg" style={{height: "205px"}}/>
            <div className="flex flex-col gap-2 p-2">
              <h2 style={{fontFamily: "serif"}}>This is a sample Blog</h2>
              <h4 className="text-gray-400" style={{fontFamily: "serif"}}>This is subtitle how it looks like</h4>
              <h4 style={{fontFamily: "serif"}}>
                <strong className="text-red-800"> Category:  </strong> Select Proposal
              </h4>
              <p>10 minutes read</p>
              <div className="flex flex-row items-center mt-2">
                <Link type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                  <FaEdit/>
                </Link>
                <Link type="button" class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
                  <MdDelete/>
                </Link>
                <Link className="underline ml-4 text-blue-500">
                  View on Website
                </Link>
                </div>
            </div>
          </div>


          <div className="flex flex-row gap-5 bg-blue-100">
            <img src="https://cdn.prod.website-files.com/621ce1736f293c5bb7029149/65a54274254aafd1312ee5d3_pexels-summer-stock-285938.jpg" style={{height: "205px"}}/>
            <div className="flex flex-col gap-2 p-2">
              <h2 style={{fontFamily: "serif"}}>This is a sample Blog</h2>
              <h4 className="text-gray-400" style={{fontFamily: "serif"}}>This is subtitle how it looks like</h4>
              <h4 style={{fontFamily: "serif"}}>
                <strong className="text-red-800"> Category:  </strong> Select Proposal
              </h4>
              <p>10 minutes read</p>
              <div className="flex flex-row items-center mt-2">
                <Link type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                  <FaEdit/>
                </Link>
                <Link type="button" class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
                  <MdDelete/>
                </Link>
                <Link className="underline ml-4 text-blue-500">
                  View on Website
                </Link>
                </div>
            </div>
          </div>



          <div className="flex flex-row gap-5 bg-blue-100">
            <img src="https://cdn.prod.website-files.com/621ce1736f293c5bb7029149/65a54274254aafd1312ee5d3_pexels-summer-stock-285938.jpg" style={{height: "205px"}}/>
            <div className="flex flex-col gap-2 p-2">
              <h2 style={{fontFamily: "serif"}}>This is a sample Blog</h2>
              <h4 className="text-gray-400" style={{fontFamily: "serif"}}>This is subtitle how it looks like</h4>
              <h4 style={{fontFamily: "serif"}}>
                <strong className="text-red-800"> Category:  </strong> Select Proposal
              </h4>
              <p>10 minutes read</p>
              <div className="flex flex-row items-center mt-2">
                <Link type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                  <FaEdit/>
                </Link>
                <Link type="button" class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
                  <MdDelete/>
                </Link>
                <Link className="underline ml-4 text-blue-500">
                  View on Website
                </Link>
                </div>
            </div>
          </div>



          <div className="flex flex-row gap-5 bg-blue-100">
            <img src="https://cdn.prod.website-files.com/621ce1736f293c5bb7029149/65a54274254aafd1312ee5d3_pexels-summer-stock-285938.jpg" style={{height: "205px"}}/>
            <div className="flex flex-col gap-2 p-2">
              <h2 style={{fontFamily: "serif"}}>This is a sample Blog</h2>
              <h4 className="text-gray-400" style={{fontFamily: "serif"}}>This is subtitle how it looks like</h4>
              <h4 style={{fontFamily: "serif"}}>
                <strong className="text-red-800"> Category:  </strong> Select Proposal
              </h4>
              <p>10 minutes read</p>
              <div className="flex flex-row items-center mt-2">
                <Link type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                  <FaEdit/>
                </Link>
                <Link type="button" class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
                  <MdDelete/>
                </Link>
                <Link className="underline ml-4 text-blue-500">
                  View on Website
                </Link>
                </div>
            </div>
          </div>

          
        </div>
      </div>
    </>
  )
};

export default Blogs;
